import { render, staticRenderFns } from "./AccountInformationList.vue?vue&type=template&id=96abfcdc&scoped=true&"
import script from "./AccountInformationList.vue?vue&type=script&lang=ts&"
export * from "./AccountInformationList.vue?vue&type=script&lang=ts&"
import style0 from "./AccountInformationList.vue?vue&type=style&index=0&id=96abfcdc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96abfcdc",
  null
  
)

export default component.exports